<template>
  <div class="row">
    <div class="col-md-12">
      <div
        class="row"
        v-if="havePermission"
      >
        <div class="col-md-12">
          <div class="filter-options">
            <div>
              <date-picker
                v-model="date"
                :placeholder="$t('placeholder.chooseDateRage')"
                format="DD/MM/YYYY"
                range
                :disabled-date="notBeforeToday"
                @input="fetchReport"
                :lang="$datepickerlocale[$i18n.locale]['lang']"
              />
            </div>
            <div
              class="btn-group pull-right margin-bottom group-options"
              role="group"
            >
              <button
                :class="`btn btn-${eachFilter.active ? 'primary' : 'default'}`"
                :key="key"
                :disabled="disabledGroupButton"
                @click="onFilterData(eachFilter)"
                v-for="(eachFilter, key) in filters"
              >
                {{ eachFilter.label }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <template v-if="can([$Permissions.backend.dashboard.viewApplicantChart])">
            <cash-hero-applicant-chart
              :first-label="$t('label.$Requested')"
              :second-label="$t('label.applicant')"
              :title="$t('label.applicant')"
            />
          </template>
        </div>
        <div class="col-md-6">
          <template v-if="can([$Permissions.backend.dashboard.viewDraftChart])">
            <cash-hero-draft-chart
              :first-label="$t('label.$Requested')"
              :second-label="$t('label.applicant')"
              :title="$t('label.draft')"
            />
          </template>
        </div>
        <div class="col-md-6">
          <template v-if="can([$Permissions.backend.dashboard.viewNewClientChart])">
            <cash-hero-new-client-chart
              :first-label="$t('label.$newClient')"
              :second-label="$t('label.newClient')"
              :title="$t('label.newClient')"
            />
          </template>
        </div>
        <div class="col-md-6">
          <template v-if="can([$Permissions.backend.dashboard.viewOldClientChart])">
            <cash-hero-old-client-chart
              :first-label="$t('label.$oldClient')"
              :second-label="$t('label.oldClient')"
              :title="$t('label.oldClient')"
            />
          </template>
        </div>
        <div class="col-md-6">
          <template v-if="can([$Permissions.backend.dashboard.viewLoanChart])">
            <cash-hero-loan-chart
              :first-label="$t('label.$Loan')"
              :second-label="$t('label.loan')"
              :title="$t('label.loan')"
            />
          </template>
        </div>
        <div class="col-md-6">
          <template v-if="can([$Permissions.backend.dashboard.viewRejectChart])">
            <cash-hero-rejected-chart
              :first-label="$t('label.$Rejected')"
              :second-label="$t('label.rejected')"
              :title="$t('label.rejected')"
            />
          </template>
        </div>
        <div class="col-md-6">
          <template v-if="can([$Permissions.backend.dashboard.viewApprovalRateChart])">
            <cash-hero-approval-rate-chart />
          </template>
        </div>
        <div class="col-md-6">
          <template v-if="can([$Permissions.backend.dashboard.viewInvestorChart])">
            <cash-hero-invest-chart
              :first-label="$t('label.$Invested')"
              :second-label="$t('label.invest')"
              :title="$t('label.invest')"
            />
          </template>
        </div>
        <div
          class="col-md-12"
          v-if="can([
            $Permissions.backend.dashboard.viewApplicantCancellationChart,
            $Permissions.backend.dashboard.viewLoanCancellationChart
          ])"
        >
          <applicant-loan-cancel-box-chart />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CashHeroApplicantChart from './charts/CashHeroApplicantChart'
import CashHeroRejectedChart from './charts/CashHeroRejectedChart'
import CashHeroInvestChart from './charts/CashHeroInvestChart'
import CashHeroApprovalRateChart from './charts/CashHeroApprovalRateChart'
import CashHeroLoanChart from './charts/CashHeroLoanChart'
import CashHeroNewClientChart from './charts/CashHeroNewClientChart'
import CashHeroOldClientChart from './charts/CashHeroOldClientChart'
import ApplicantLoanCancelBoxChart from '@/views/dashboard/_components/ApplicantLoanCancelBoxChart'
import CashHeroDraftChart from '@/views/dashboard/charts/CashHeroDraftChart'

export default {
  name: 'CashHeroChart',
  components: {
    CashHeroDraftChart,
    ApplicantLoanCancelBoxChart,
    CashHeroOldClientChart,
    CashHeroNewClientChart,
    CashHeroLoanChart,
    CashHeroApprovalRateChart,
    CashHeroInvestChart,
    CashHeroRejectedChart,
    CashHeroApplicantChart
  },
  data () {
    return {
      date: null
    }
  },
  computed: {
    ...mapState({
      filters: state => state.dashboard.filters,
      selectedFilter: state => state.dashboard.buttonGroupActive,
      daterange: state => state.dashboard.daterange
    }),
    disabledGroupButton () {
      if (this.daterange && this.daterange[0] && this.daterange[1]) {
        return true
      }
      return false
    },
    havePermission () {
      const permissions = [
        'view-applicant-chart',
        'view-draft-chart',
        'view-new-client-chart',
        'view-old-client-chart',
        'view-loan-chart',
        'view-reject-chart',
        'view-approval-rate-chart',
        'view-investor-chart',
        'view-applicant-cancellation-chart',
        'view-loan-cancellation-chart',
        'view-compare-table'
      ]
      return this.can(permissions)
    }
  },
  watch: {
    '$i18n.locale': function () {
      this.$store.commit('dashboard/setFilters', [
        { label: this.$t('filter.day'), value: 'day', active: true },
        { label: this.$t('filter.week'), value: 'week', active: false },
        { label: this.$t('filter.month'), value: 'month', active: false },
        { label: this.$t('filter.year'), value: 'year', active: false },
        { label: this.$t('filter.lifetime'), value: 'life_time', active: false }
      ])
    }
  },
  methods: {
    notBeforeToday (date) {
      return date > new Date(new Date().setHours(0, 0, 0, 0))
    },
    onFilterData (filter) {
      this.$store.commit('dashboard/changeButtonGroupActive', filter)
    },
    fetchReport () {
      this.$store.commit('dashboard/setDateRange', this.date)
    }
  },
  mounted () {
    this.$store.dispatch('dashboard/setButtonGroupActive', {
      label: this.$t('filter.day'),
      value: 'day',
      active: true
    })
    this.$store.commit('dashboard/setFilters', [
      { label: this.$t('filter.day'), value: 'day', active: true },
      { label: this.$t('filter.week'), value: 'week', active: false },
      { label: this.$t('filter.month'), value: 'month', active: false },
      { label: this.$t('filter.year'), value: 'year', active: false },
      { label: this.$t('filter.lifetime'), value: 'life_time', active: false }
    ])
  }
}
</script>

<style scoped>
.filter-options {
  display: flex;
  justify-content: space-between;
}
</style>
